import { render, staticRenderFns } from "./generic-link.vue?vue&type=template&id=23bb7e63"
import script from "./generic-link.vue?vue&type=script&lang=js"
export * from "./generic-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports